import React from 'react';
import IMEAssessmentsView from '@components/admin-routes/IMEAssessments';

export default function IMEAssessments(props) {
  return <IMEAssessmentsView {...props} />;
}
